import React, { useEffect, useMemo, useState } from "react";
import { getRoles } from "common/services/users.service";
import { normalize } from "common/lib/normalize";

type RoleFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const RoleFilter = ({ onChange, value }: RoleFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getRoles({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.roles));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <select
      className="form-control"
      data-choices
      data-choices-search-false
      name="choices-single-default2"
      id="choices-single-default2"
      onChange={(e) => {
        onChange(e.target.value);
      }}
      value={value}
    >
      {loading && <option>Loading...</option>}
      <option value="">Select Role</option>
      {options.map((option: any) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default RoleFilter;
